module.exports = __webpack_public_path__ + "img/size.7b16758e.png";